import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import platformDetection from './PlatformDetection';
import reactNativeBridge from './ReactNativeBridge';

const durationUtils = {
    transformDuration (duration) {
        var totalSeconds = parseInt(duration / 1000);
        const miliseconds = duration - totalSeconds * 1000;

        if (miliseconds > 500)
            totalSeconds = totalSeconds + 1;

        const minutes = parseInt(totalSeconds / 60);
        const seconds = totalSeconds - minutes * 60;

        var minValue;

        if (minutes < 10)
            minValue = '0' + minutes;
        else
            minValue = '' + minutes;

        var secValue;

        if (seconds < 10)
            secValue = '0' + seconds;
        else
            secValue = '' + seconds;

        return minValue + ':' + secValue;
    },
    transformDurationFromStringToSeconds(str) {
        if (!str)
            return 0;

        var elements = str.split(':');
        var duration;

        if (!elements || elements.length < 1)
            return 0;

        var seconds = parseInt(elements[1]);
        var minutes = parseInt(elements[0]);

        duration = 60 * minutes + seconds;

        return duration; //seconds
    },

    // Recording duration
    recordingDurationVar: undefined,
    endRecordingCallback: undefined,

    startRecording(endRecordingCallback) {
        this.endRecordingCallback = endRecordingCallback;
        this.clearRecordingDuration();

        var duration;

        if (platformDetection.isIOS()) {
            if (audioToolUtils.isAudioTool())
                duration = 5 * 60 * 1000; // 5min for AE tool
            else
                duration = 2 * 60 * 1000; // 2min for Cartoonist tool
        } else {
            if (platformDetection.isChromeBook()) {
                if (audioToolUtils.isAudioTool())
                    duration = 10 * 60 * 1000; // 15min for AE tool
                else
                    duration = 2 * 60 * 1000; // 2min for Cartoonist tool
            } else {
                if (audioToolUtils.isAudioTool())
                    duration = 15 * 60 * 1000; // 15min for AE tool
                else
                    duration = 2 * 60 * 1000; // 2min for Cartoonist tool
            }
        }

        this.recordingDurationVar = setTimeout(this.stopRecording.bind(this), duration);
    },
    stopRecording() {
        this.clearRecordingDuration();

        if (this.endRecordingCallback)
            this.endRecordingCallback();
    },
    clearRecordingDuration() {
        if (this.recordingDurationVar)
            clearTimeout(this.recordingDurationVar);
    }
};

export default durationUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/DurationUtils.js
 **/